// extracted by mini-css-extract-plugin
export var button = "_ne-2";
export var card = "_ne-0";
export var closeButtonContainer = "_ne-3";
export var iconContainer = "_ne-1";